import { render } from "./SvgSwiftTrailerDriver.vue?vue&type=template&id=4f7efb56&ts=true"
import script from "./SvgSwiftTrailerDriver.vue?vue&type=script&lang=ts"
export * from "./SvgSwiftTrailerDriver.vue?vue&type=script&lang=ts"

import "./SvgSwiftTrailerDriver.vue?vue&type=style&index=0&id=4f7efb56&lang=css"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__